import React from 'react';

import styled from 'styled-components';

import useAuditRefs from 'hooks/activity-logs/useAuditRefs';
import useAuditUserResolver from 'hooks/activity-logs/useAuditUserResolver';

import { ActivtyLog } from 'models/activty-log.model';

import AuditTrailEntry from './AuditTrailEntry';

type AuditTrailContentProps = {
    data: ActivtyLog[];
    date: string;
    showTarget?: boolean;
    getSummary?: (log: ActivtyLog, userLabel: string) => string;
};
const AuditTrailContent: React.FC<
    React.PropsWithChildren<AuditTrailContentProps>
> = ({ data, date, showTarget, getSummary }) => {
    const { resolveUser } = useAuditUserResolver();
    const refs = useAuditRefs();
    return (
        <LogList key={date}>
            {[...data]
                .sort(
                    (a, b) =>
                        new Date(b.created_at).getTime() -
                        new Date(a.created_at).getTime(),
                )
                .map((log) => {
                    const userLabel = resolveUser(log.user_id, log.user_name);
                    return (
                        <AuditTrailEntry
                            key={log.id}
                            log={log}
                            userLabel={userLabel}
                            showTarget={showTarget}
                            refs={refs}
                            summary={getSummary?.(log, userLabel)}
                        />
                    );
                })}
        </LogList>
    );
};
const LogList = styled.ul({
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    // Lets entries rearrange themselves in narrow hosts like history drawers.
    containerType: 'inline-size',
});
export default AuditTrailContent;
